import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { IBlogCategory } from '@/models/blogCategories.model';
import { CategoryLocaleCodes } from '@/models/categories.model';
import BlogCategoriesTableActions from './BlogCategoriesTableActions';

type TGetBlogCategoriesColumns = {
  t: TFunction;
  onEdit: (row: IBlogCategory) => void;
  onDelete: (row: IBlogCategory) => void;
  canManage: boolean;
};

export const getBlogCategoriesTableColumns = ({
  t,
  onEdit,
  onDelete,
  canManage,
}: TGetBlogCategoriesColumns): ColumnsType<IBlogCategory> => [
  {
    title: t('blog_category_column_position'),
    dataIndex: 'position',
    key: 'position',
    width: 100,
  },
  {
    title: t('blog_category_column_name'),
    key: 'name_uk',
    render: (_, record) => {
      const loc = record.locale?.[CategoryLocaleCodes.UK];
      const name = loc?.name?.trim();
      if (!name) return <span>—</span>;
      return <span>{name}</span>;
    },
  },
  ...(canManage
    ? [
        {
          title: t('filter_actions_column_title'),
          key: 'actions',
          width: 140,
          render: (_: unknown, record: IBlogCategory) => (
            <BlogCategoriesTableActions record={record} onEdit={onEdit} onDelete={onDelete} />
          ),
        },
      ]
    : []),
];
